<template>
  <div class="page-container">
    <AppHeader title="Theme Images Settings" />

    <div class="container-fluid">
      <!-- Action Bar -->
      <!-- <div v-if="!showImageForm" class="action-bar">
        <button class="btn btn-primary action-btn" @click="handleNewImage">
          <i class="glyphicon glyphicon-plus"></i> New Image
        </button>
      </div> -->

      <!-- Images Table -->
      <div v-if="!showImageForm" class="table-container">
        <div class="table-responsive table-wrap">
          <table class="table table-striped table-hover">
            <thead>
              <tr>
                <th>Image</th>
                <th>Description</th>
                <th>Preview</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(image, index) in images" :key="index">
                <td>{{ imageMapping[image.Key || image.key] || (image.Key || image.key) }}</td>
                <td>{{ image.Description || image.description || '-' }}</td>
                <td class="preview-cell">
                  <img :src="getImageUrl(image.Image || image.image)" class="image-preview-thumb" alt="Preview">
                </td>
                <td>
                  <button class="btn btn btn-success me-2" @click="handleEditImage(image)">Edit</button>
                  <!-- <button class="btn btn btn-danger" @click="handleDeleteImage(image)">Delete</button> -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Add/Edit Image Form -->
      <div v-if="showImageForm" class="form-card">
        <div class="card-header">
          <h3>{{ isEditingImage ? 'Edit Image' : 'Add New Image' }}</h3>
        </div>
        <div class="card-body">
          <!-- <div class="form-group mb-3">
            <label>Image Key</label>
            <div class="input-group">
               <input 
                type="text" 
                v-model="imageForm.key" 
                class="form-control" 
                placeholder="e.g. login_image, home_image" 
                list="predefined-image-keys"
                :disabled="isEditingImage"
              >
              <datalist id="predefined-image-keys">
                <option value="login_image">Login Background</option>
                <option value="home_image">Dashboard Background</option>
              </datalist>
            </div>
            <small class="text-muted">Select a standard key or enter a custom one.</small>
          </div> -->

          <div class="form-group mb-3">
            <label>Description</label>
            <input 
              type="text" 
              v-model="imageForm.description" 
              class="form-control" 
              placeholder="e.g. Background for login screen"
            >
          </div>

          <div class="form-group mb-3">
            <label>Upload Image</label>
            <input type="file" class="form-control" @change="onFileChange" accept="image/*">
            <div v-if="imagePreview" class="mt-2 text-center">
              <img :src="imagePreview" class="image-preview-large" alt="Preview">
            </div>
          </div>

          <div class="actions-row mt-4">
            <button class="btn btn-danger me-2" @click="cancelImageForm">Cancel</button>
            <button class="btn btn-success" @click="saveImage">{{ isEditingImage ? 'Update' : 'Save' }}</button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import AppHeader from "@/components/AppHeader";
import commonServices from "@/shared/commonServices";
import axios from "axios";
import Swal from 'sweetalert2';

export default {
  name: "ThemeImagesSettings",
  components: { AppHeader },
  mixins: [commonServices],
  data() {
    return {
      images: [],
      showImageForm: false,
      isEditingImage: false,
      imageMapping: {
        'login_image': 'Login Background',
        'home_image': 'Dashboard Background',
        // 'logo': 'System Logo'
      },
      imageForm: {
        id: null,
        key: "",
        description: "",
        file: null
      },
      imagePreview: null
    };
  },
  mounted() {
    this.fetchImages();
  },
  methods: {
    async fetchImages() {
      try {
        let dataURL = this.apiURL + "ThemeImages/getThemeImages";
        let response = await axios.get(dataURL);
        if (response.data && Array.isArray(response.data)) {
          this.images = response.data;
        } else {
          this.images = [];
        }
      } catch (error) {
        console.error("Error fetching images:", error);
      }
    },
    getImageUrl(path) {
      if (!path) return '';
      // Assuming apiURL ends with 'api/', remove it to get base URL
      let baseURL = this.apiURL.replace('api/', '');
      return baseURL + path;
    },
    handleNewImage() {
      this.isEditingImage = false;
      this.imageForm = { id: null, key: "", description: "", file: null };
      this.imagePreview = null;
      this.showImageForm = true;
    },
    handleEditImage(image) {
      this.isEditingImage = true;
      this.imageForm = { 
        id: image.Id || image.id, 
        key: image.Key || image.key, 
        description: image.Description || image.description || "",
        file: null
      };
      this.imagePreview = this.getImageUrl(image.Image || image.image);
      this.showImageForm = true;
    },
    onFileChange(e) {
      const file = e.target.files[0];
      if (file) {
        this.imageForm.file = file;
        this.imagePreview = URL.createObjectURL(file);
      }
    },
    cancelImageForm() {
      this.showImageForm = false;
    },
    async saveImage() {
      if (!this.imageForm.key) {
        Swal.fire('Error', 'Key is required', 'error');
        return;
      }
      if (!this.isEditingImage && !this.imageForm.file) {
        Swal.fire('Error', 'Image file is required', 'error');
        return;
      }

      try {
        let formData = new FormData();
        formData.append('Key', this.imageForm.key);
        formData.append('Description', this.imageForm.description);
        if (this.imageForm.file) {
          formData.append('Image', this.imageForm.file);
        }
        
        let dataURL = this.apiURL + "ThemeImages/saveThemeImage";
        
        let response = await axios.post(dataURL, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        
        if (response.data.status === 'success') {
           Swal.fire('Success', 'Image saved successfully', 'success');
           this.showImageForm = false;
           this.fetchImages();
        } else {
           Swal.fire('Error', response.data.message || 'Failed to save image', 'error');
        }
      } catch (error) {
        console.error("Error saving image:", error);
        Swal.fire('Error', 'An error occurred', 'error');
      }
    },
    async handleDeleteImage(image) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            let dataURL = this.apiURL + "ThemeImages/deleteThemeImage";
            await axios.post(dataURL, { Key: image.Key || image.key });
            
            Swal.fire('Deleted!', 'Image has been deleted.', 'success');
            this.fetchImages();
          } catch (error) {
             console.error("Error deleting image:", error);
             Swal.fire('Error', 'Failed to delete image', 'error');
          }
        }
      })
    }
  }
};
</script>

<style scoped>
.page-container {
  min-height: 100vh;
  background-color: var(--theme-bg-end);
  color: var(--theme-text-main);
}

.content-wrapper {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.action-bar {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
}

.actions-row {
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;
  gap: 15px;
}

.table-container {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  overflow: hidden;
}

.table {
  color: white;
  margin-bottom: 0;
}

.table th, .table td {
  border-color: rgba(255, 255, 255, 0.1);
  vertical-align: middle;
}

.preview-cell { display: flex; align-items: center; justify-content: center; }

.image-preview-thumb {
  max-width: 100px;
  max-height: 60px;
  border-radius: 4px;
  border: 1px solid rgba(255,255,255,0.2);
}

.form-card {
  background: rgba(30, 35, 50, 0.9);
  border-radius: 12px;
  padding: 0;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0,0,0,0.3);
  max-width: 600px;
  margin: 0 auto;
}

.card-header {
  background: rgba(255, 255, 255, 0.05);
  padding: 15px 20px;
  border-bottom: 1px solid rgba(255,255,255,0.1);
}

.card-header h3 {
  margin: 0;
  font-size: 1.25rem;
  color: white;
}

.card-body {
  padding: 20px;
}

.form-control {
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: white;
}

.form-control:focus {
  background: rgba(0, 0, 0, 0.3);
  border-color: var(--theme-primary);
  color: white;
  box-shadow: none;
}

.text-muted {
  color: rgba(255, 255, 255, 0.5) !important;
}

.me-2 { margin-right: 0.5rem; }
.mb-3 { margin-bottom: 1rem; }
.mt-4 { margin-top: 1.5rem; }
.mt-2 { margin-top: 0.5rem; }
.text-center { text-align: center; }

.image-preview-large {
  max-width: 100%;
  max-height: 200px;
  border-radius: 8px;
  border: 1px solid rgba(255,255,255,0.2);
}
</style>
